import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Logo from "../../components/Logo";
import LoginWithPasswordForm from "../../components/auth/LoginWithPasswordForm";
import LoginWithOTPForm from "../../components/auth/LoginWithOTPForm";
import ForgotPasswordForm from "../../components/auth/ForgotPasswordForm";

export default function LoginPage() {
  const [method, setMethod] = useState("password"); // 'password' | 'otp' | 'forgot'

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md border">
        {/* هدر */}
        <div className="mb-6 text-center relative">
          <Link to={"/"}><Logo /></Link>
          <h1 className="text-xl font-medium mt-2">
            {method === "forgot" ? "بازیابی رمز عبور" : "ورود به حساب کاربری"}
          </h1>
          {(method === "forgot") ? (<button onClick={() => setMethod("password")} className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-800">
            <FaArrowRight />
          </button>): (<Link to={"/"}><FaArrowRight /></Link>)}
        </div>

        {/* سوییچر متد ورود (فقط در حالت‌های اصلی نمایش داده شود) */}
        {method !== "forgot" && (
            <div className="flex border-b mb-6">
                <button
                    className={`flex-1 py-2 text-sm font-medium ${method === "password" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500"}`}
                    onClick={() => setMethod("password")}
                >رمز عبور</button>
                <button
                    className={`flex-1 py-2 text-sm font-medium ${method === "otp" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500"}`}
                    onClick={() => setMethod("otp")}
                >رمز یک‌بار مصرف</button>
            </div>
        )}

        {/* نمایش فرم انتخابی */}
        {method === "password" && <LoginWithPasswordForm />}
        {method === "otp" && <LoginWithOTPForm />}
        {method === "forgot" && <ForgotPasswordForm onBackToLogin={() => setMethod("password")} />}

        {/* لینک ثبت نام (فقط در حالت ورود) */}
        {method !== "forgot" && (
            <div className="flex flex-col items-center gap-2 mt-4 text-sm">
                <button onClick={() => setMethod("forgot")} className="text-blue-600 hover:underline">فراموشی رمز عبور</button>
                <Link to="/user-register" className="text-blue-600 hover:underline">ثبت نام</Link>
            </div>
        )}
      </div>
    </div>
  );
}